// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"2fcc063d","189":"f3beb22e","200":"05cf0613","271":"5b7577ee","283":"df988f2a","353":"094939a8","381":"8f6ce7c3","396":"abf9add5","499":"c77bea54","663":"67d6d664","744":"fbc87f57","760":"865a1630","830":"8e128ce9","904":"6f6c6864","908":"2852c5c0"}[chunkId] + ".chunk.js";
};